import _ from 'lodash';
import React, { useContext, useEffect, useState } from 'react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import { toast } from 'react-toastify';
import { FaEye, FaEyeSlash } from "react-icons/fa";
import './ModalEditInfo.scss'
import { updateAdminInfo } from '../../services/adminService';
import { AdminContext } from '../../context/AdminContext'
import { logoutUser } from '../../services/userServices';
import { useNavigate } from 'react-router-dom/dist';
import { useDispatch, useSelector } from 'react-redux';
import { logout } from '../../redux/slice/userSlice';



const ModalEditInfo = (props) => {

    const { dataModalFromParent, isShow } = props
    const admin = useSelector(state => state.admin)
    const dispatch = useDispatch()
    let navigate = useNavigate()


    const validInputDefault = {
        // adminCode: true,
        fullName: true,
        cccdId: true,
        phoneNumber: true,
        email: true,
        password: true,
        repassword: true
    }

    const defaultData = {
        // adminCode: '',
        fullName: '',
        cccdId: '',
        phoneNumber: '',
        email: '',
        password: '',
        repassword: '',
        oldAdminCode: ''
    }

    const [showPassword, setShowPassword] = useState(false)
    const [showRePassword, setShowRePassword] = useState(false)
    const [validInput, setValidInput] = useState(validInputDefault)
    const [isSaveDisabled, setIsSaveDisabled] = useState(true)
    const [adminData, setAdminData] = useState(defaultData)
    const [isShowConfirm, setShowConfirm] = useState(false)

    const togglePasswordVisibility = () => {
        setShowPassword(!showPassword)
    }

    const toggleRePasswordVisibility = () => {
        setShowRePassword(!showRePassword)
    }

    useEffect(() => {
        setAdminData({ ...defaultData, repassword: '', oldAdminCode: dataModalFromParent.adminCode })
        console.log('adminData: ', adminData);
        setIsSaveDisabled(true)
    }, [props.isShow, dataModalFromParent])

    useEffect(() => {

    }, [adminData])


    const handleOnchangeInput = (value, name) => {
        let _adminData = _.cloneDeep(adminData)
        _adminData[name] = value
        setAdminData(_adminData)
        //_adminData.adminCode === '' && 
        if (_adminData.fullName === '' && _adminData.cccdId === '' && _adminData.phoneNumber === '' && _adminData.email === '' && _adminData.password === '' && _adminData.repassword === '')
            setIsSaveDisabled(true)
        else
            setIsSaveDisabled(false)
    }

    const isEmptyInput = () => {
        setValidInput(validInputDefault)
        let field = ['fullName', 'cccdId', 'phoneNumber', 'email', 'password', 'repassword']
        let check = true;
        for (let i = 0; i < field.length; i++) {
            if (!adminData[field[i]]) {
                let _validInput = _.cloneDeep(validInputDefault)
                _validInput[field[i]] = false
                setValidInput(_validInput)

                toast.error(`${field[i]} is empty.`)
                check = false;
                break;
            }
        }
        return check;
    }

    const isValidValue = () => {
        // adminCode: '',
        // fullName: '',
        // cccdId: '',
        // phoneNumber: '',
        // email: '',
        // password: '',
        // repassword: ''
        const regexCode = /^\d{8}$/
        // const regexFullName = 
        const regexCCCD = /^\d{12}$/
        const regexPhone = /^0\d{9}$/
        const regexEmail = /^[a-zA-Z0-9!#$%&'*+/=?^_`{|}~.-]{5,16}@gmail\.com$/;
        const regexPwd = /^[\s\S]{7,16}$/;

        // if(regexCode.test(adminData['adminCode']) === false){
        //     toast.error('Mã quản trị viên không hợp lệ.')
        //     setValidInput({...validInputDefault, adminCode: false})
        //     return false;
        // }else{
        //     setValidInput({...validInputDefault, adminCode: true})
        // }

        if (regexCCCD.test(adminData['cccdId']) === false) {
            toast.error('Mã CCCD không hợp lệ.')
            setValidInput({ ...validInputDefault, cccdId: false })
            return false;
        } else {
            setValidInput({ ...validInputDefault, cccdId: true })
        }

        if (regexPhone.test(adminData['phoneNumber']) === false) {
            toast.error('Số điện thoại không hợp lệ.')
            setValidInput({ ...validInputDefault, phoneNumber: false })
            return false
        } else {
            setValidInput({ ...validInputDefault, phoneNumber: true })
        }

        if (regexEmail.test(adminData['email']) === false) {
            toast.error('Email không hợp lệ.')
            setValidInput({ ...validInputDefault, email: false })
            return false
        } else {
            setValidInput({ ...validInputDefault, email: true })
        }

        if (regexPwd.test(adminData['password']) === false) {
            toast.error('Mật khẩu không hợp lệ.')
            setValidInput({ ...validInputDefault, password: false })
            return false;
        } else {
            setValidInput({ ...validInputDefault, password: true })
        }

        if (adminData['password'] !== adminData['repassword']) {
            toast.error('Mật khẩu không khớp.')
            setValidInput({ ...validInputDefault, password: false, repassword: false })
            return false;
        } else {
            setValidInput({ ...validInputDefault, password: true, repassword: true })
        }

        return true;
    }

    const isValidInput = () => {
        return isEmptyInput() && isValidValue()
    }

    const authenticateViaEmail = async (input) => {
        return true;
    }

    const showConfirm = () => {
        setShowConfirm(true)
    }

    const closeConfirm = () => {
        setShowConfirm(false)
    }

    const handleLogout = async () => {
        let data = await logoutUser()   //clear cookie
        dispatch(logout())               //clear user in context (clear navbar)
        if (data && data.ok) { //check tu server
            toast.success('Đã đăng xuất')
            navigate('/login')
        } else {
            toast.error(data.message)
        }
    }

    const handleConfirmUpdate = async () => {
        let check = isValidInput()
        if (check) {
            console.log('data to update: ', adminData);
            let isAuthenticatedViaEmail = await authenticateViaEmail({ adminData })
            if (isAuthenticatedViaEmail) {
                let response = await updateAdminInfo(adminData)
                console.log('response: ', response);
                if (response.ok) {
                    toast.success(response.message)
                    props.onClose()
                    handleLogout()
                }
                else {
                    toast.error(response.message)
                }
            }
        }
    }

    const handleCloseModalEdit = () => {
        props.onClose()
        setAdminData(defaultData)
        setValidInput(validInputDefault)
    }

    return (
        <>
            <Modal show={props.isShow} className='modal-edit' onHide={() => handleCloseModalEdit()}>
                <Modal.Header closeButton>
                    <Modal.Title>Cập nhật thông tin</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className='modal-edit-content-body row'>
                        {/* <div className='col-xl-6 col-md-12 col-sm-12 form-group'>
                            <label>Mã: </label>
                            <input value={adminData.adminCode} className={validInput.adminCode === true ? 'form-control' : 'form-control is-invalid'} type='email' onChange={(event)=> handleOnchangeInput(event.target.value, "adminCode")}></input>
                            {!validInput.adminCode && <span className='err'>Sử dụng mã do nhà trường cung cấp.</span>}
                        </div> */}
                        <div className='col-xl-6 col-md-12 col-sm-12 form-group'>
                            <label>Họ tên: </label>
                            <input value={adminData.fullName} className={validInput.fullName === true ? 'form-control' : 'form-control is-invalid'} type='text' onChange={(event) => handleOnchangeInput(event.target.value, "fullName")}></input>
                            {!validInput.fullName && <span className='err'></span>}
                        </div>
                        <div className='col-xl-6 col-md-12 col-sm-12 form-group'>
                            <label>Mã CCCD: </label>
                            <input value={adminData.cccdId} className={validInput.cccdId === true ? 'form-control' : 'form-control is-invalid'} type='text' onChange={(event) => handleOnchangeInput(event.target.value, "cccdId")}></input>
                            {!validInput.cccdId && <span className='err'>Sử dụng mã căn cước công dân</span>}
                        </div>
                        <div className='col-xl-6 col-md-12 col-sm-12 form-group'>
                            <label>Số điện thoại: </label>
                            <input value={adminData.phoneNumber} className={validInput.phoneNumber === true ? 'form-control' : 'form-control is-invalid'} type='text' onChange={(event) => handleOnchangeInput(event.target.value, "phoneNumber")}></input>
                            {/* <span className='err'></span> */}
                        </div>
                        <div className='col-xl-6 col-md-12 col-sm-12 form-group'>
                            <label>Email: </label>
                            <input value={adminData.email} className={validInput.email === true ? 'form-control' : 'form-control is-invalid'} type='email' onChange={(event) => handleOnchangeInput(event.target.value, "email")}></input>
                            {!validInput.email && <span className='err'>Sử dụng email có định dạng @gmail.com</span>}
                        </div>
                        <div className='col-xl-6 col-md-12 col-sm-12 form-group'>
                            <label>Mật khẩu: </label>
                            <div className='d-flex'>
                                <div>
                                    <input value={adminData.password} className={validInput.password === true ? 'form-control' : 'form-control is-invalid'} type={showPassword ? 'text' : 'password'} onChange={(event) => handleOnchangeInput(event.target.value, "password")}></input>
                                    {!validInput.password && <span className='err'>Mật khẩu từ 7 - 16 ký tự bất kỳ</span>}
                                </div>
                                <Button
                                    className="password-toggle-btn"
                                    onClick={togglePasswordVisibility}
                                    style={{ marginLeft: '8px', boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)', borderStyle: "solid" }}
                                >
                                    {showPassword ? <FaEyeSlash /> : <FaEye />}
                                </Button>
                            </div>
                        </div>
                        <div className='col-xl-6 col-md-12 col-sm-12 form-group'>
                            <label>Nhập lại mật khẩu: </label>
                            <div className='d-flex'>
                                <div>
                                    <input className={validInput.repassword === true ? 'form-control' : 'form-control is-invalid'} type={showRePassword ? 'text' : 'password'} onChange={(event) => handleOnchangeInput(event.target.value, "repassword")}></input>
                                    {!validInput.repassword && <span className='err'>Hãy nhập mật khẩu chính xác</span>}
                                </div>
                                <Button
                                    className="password-toggle-btn"
                                    onClick={toggleRePasswordVisibility}
                                    style={{ marginLeft: '8px', boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)', borderStyle: "solid" }}
                                >
                                    {showRePassword ? <FaEyeSlash /> : <FaEye />}
                                </Button>
                            </div>
                        </div>
                    </div>
                </Modal.Body>

                <Modal.Footer>
                    <Button variant="secondary" onClick={() => handleCloseModalEdit()}>Hủy</Button>
                    <Button variant="primary" disabled={isSaveDisabled} onClick={() => showConfirm()} >Lưu</Button>
                </Modal.Footer>
            </Modal>
            <Modal show={isShowConfirm} onHide={() => closeConfirm()}>
                <Modal.Header closeButton>
                    <Modal.Title>Thông báo</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <p>Sau khi cập nhật thông tin sẽ tự động đăng xuất.</p>
                </Modal.Body>

                <Modal.Footer>
                    <Button variant="secondary" onClick={() => closeConfirm()}>Hủy</Button>
                    <Button variant="primary" onClick={() => handleConfirmUpdate()}>Đồng ý</Button>
                </Modal.Footer>
            </Modal>
        </>
    );
}

export default ModalEditInfo;